var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"company-finished"},[_c('h1',[_vm._v("恭喜您信息已提交")]),_vm._v(" "),_c('p',[_vm._v("您提交的会员信息，将在3个工作日进行审核，请耐心等待！")]),_vm._v(" "),_c('el-link',{staticStyle:{"margin-top":"20px"},attrs:{"type":"warning"},on:{"click":_vm.ToMemberCenter}},[_vm._v("返回会员中心")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226cc18c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Me/companyFinished/companyFinished.vue
// module id = null
// module chunks = 